import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PermissionAclService } from '../services/permission-acl.service';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class ConsultaGeralGuard implements CanActivate {
  // Mesma lógica usada para o Minhas Responsabilidades

  constructor(
    private permissionAcl: PermissionAclService
  ){}

  canActivate():  Promise<boolean>  {

    return new Promise((resolve,reject)=>{
      this.permissionAcl.getAllPermissions().subscribe({
        next: (r) => {
          if(r.permissionConsultaGeral === false){
            Swal.fire({
              title: 'Erro',
              text: 'Usuário sem permissão',
              icon: 'error',
              customClass: 'sw-system',
            } as SweetAlertOptions);
            reject('Usuário sem permissão');
          }
          resolve(r.result);
        },
        error: (e) => reject(e)
      })
    });
  }

}
